'use client'
import {
  Input_default
} from "./chunk-OU23QZUL.mjs";
import {
  Responsive_default
} from "./chunk-SJUQILRS.mjs";
import {
  Typography_default
} from "./chunk-QNSUZHUC.mjs";
import {
  Button_default
} from "./chunk-5TLHZ4PW.mjs";
import {
  Spinner_default
} from "./chunk-K2IT7DRF.mjs";
import {
  useUi
} from "./chunk-Y3GT52GT.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/Menu/Menu.tsx
import { Fragment, useMemo as useMemo2, useState } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { twMerge as twMerge3 } from "tailwind-merge";
import { useTranslation as useTranslation3 } from "@wbk/config";

// src/Menu/Search.tsx
import { useTranslation } from "@wbk/config";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
var MenuSearch = (_a) => {
  var _b = _a, { loading, onLocalSearch, ref } = _b, configs = __objRest(_b, ["loading", "onLocalSearch", "ref"]);
  const { t } = useTranslation("ui_common");
  return /* @__PURE__ */ jsx(
    Input_default,
    __spreadProps(__spreadValues({
      ref,
      autoFocus: true,
      type: "search",
      placeholder: t("ui_common:search_placeholder"),
      endIcon: loading ? /* @__PURE__ */ jsx("div", { className: "flex h-full items-center justify-end px-2", children: /* @__PURE__ */ jsx(Spinner_default, { className: "h-4 w-4" }) }) : null
    }, configs), {
      groupClassName: twMerge("sticky top-0 z-10 p-1 bg-body", configs == null ? void 0 : configs.groupClassName),
      onChange: (value) => {
        if (configs == null ? void 0 : configs.onChange) {
          return configs.onChange(value);
        }
        onLocalSearch(value);
      },
      onKeyDownCapture: (e) => {
        var _a2;
        if (!((_a2 = e.code) == null ? void 0 : _a2.includes("Arrow"))) {
          e.stopPropagation();
        }
      },
      onClick: (e) => {
        e.stopPropagation();
      }
    })
  );
};
var Search_default = MenuSearch;

// src/Menu/Item.tsx
import { useMemo } from "react";
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx2 } from "react/jsx-runtime";
var MenuItem = (_a) => {
  var _b = _a, { option, value, className, children, ref } = _b, props = __objRest(_b, ["option", "value", "className", "children", "ref"]);
  const selected = useMemo(() => {
    if (Array.isArray(value)) {
      return value.some((o) => o.value === option.value);
    }
    return (value == null ? void 0 : value.value) === option.value;
  }, [value, option]);
  return /* @__PURE__ */ jsx2(
    Button_default,
    __spreadProps(__spreadValues({
      shape: "text",
      theme: "action",
      className: twMerge2(
        "data-[selected=true]:bg-primary/20 enabled:hover:bg-primary/15 enabled:focus:bg-primary/15 aria-disabled:bg-input-disabled aria-disabled:text-text-disabled block w-full rounded-none p-4 text-start outline-none aria-disabled:cursor-not-allowed",
        className
      ),
      disabled: option.disabled,
      "data-selected": selected,
      "aria-disabled": option.disabled
    }, props), {
      ref,
      children: children || option.text || option.value
    })
  );
};
var Item_default = MenuItem;

// src/Menu/Trigger.tsx
import { useTranslation as useTranslation2 } from "@wbk/config";
import { ChevronIcon } from "@wbk/svg";
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var MenuTrigger = (_a) => {
  var _b = _a, { value, arrow: arrowProp } = _b, trigger = __objRest(_b, ["value", "arrow"]);
  const { t } = useTranslation2("ui_common");
  const arrow = arrowProp != null ? arrowProp : true;
  return /* @__PURE__ */ jsxs(Button_default, __spreadProps(__spreadValues({ type: "button", theme: "action", shape: "text" }, trigger), { children: [
    Array.isArray(value) ? /* @__PURE__ */ jsx3(Typography_default, { as: "div", className: "grow truncate text-start", children: value.map((v) => v.text || v.label || v.value).join(", ") || (trigger == null ? void 0 : trigger.placeholder) || t("ui_common:select") }) : /* @__PURE__ */ jsx3(Typography_default, { as: "div", className: "grow text-start", children: (value == null ? void 0 : value.text) || (value == null ? void 0 : value.value) || (trigger == null ? void 0 : trigger.placeholder) || t("ui_common:select") }),
    arrow && /* @__PURE__ */ jsx3(ChevronIcon, { className: "ms-1 h-2.5 w-2.5 rotate-90" })
  ] }));
};
var Trigger_default = MenuTrigger;

// src/Menu/Menu.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var MenuList = ({
  options,
  value,
  onChange,
  render,
  trigger,
  menu,
  item,
  search,
  className,
  error,
  hideErrorSpace,
  ref,
  portal = true
}) => {
  const [query, setQuery] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const { dir } = useUi();
  const { t } = useTranslation3("ui_common");
  const Portal3 = portal ? DropdownMenuPrimitive.Portal : Fragment;
  const open = () => {
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
  };
  const handleSearch = (value2) => {
    setQuery(value2);
  };
  const selected = useMemo2(() => {
    if (value == null ? void 0 : value.value) {
      return value;
    }
    return options.find((o) => o.value === value);
  }, [value, options]);
  const filterdOptions = useMemo2(() => {
    if (!query) return options;
    return options.filter(
      (option) => {
        var _a, _b, _c, _d;
        return ((_b = (_a = option.keyword) == null ? void 0 : _a.toLowerCase()) == null ? void 0 : _b.includes(query.toLowerCase())) || ((_d = (_c = option.value) == null ? void 0 : _c.toLowerCase()) == null ? void 0 : _d.includes(query.toLowerCase()));
      }
    );
  }, [options, query]);
  return /* @__PURE__ */ jsxs2(
    "div",
    {
      className,
      ref,
      tabIndex: -1,
      children: [
        /* @__PURE__ */ jsxs2(DropdownMenuPrimitive.Root, { dir, open: isOpen, onOpenChange: (open2) => setIsOpen(open2), children: [
          /* @__PURE__ */ jsx4(DropdownMenuPrimitive.Trigger, { asChild: true, children: render ? render({ close, open, isOpen, selected }) : /* @__PURE__ */ jsx4(Trigger_default, __spreadProps(__spreadValues({}, trigger), { value: selected })) }),
          /* @__PURE__ */ jsx4(Portal3, { children: /* @__PURE__ */ jsxs2(
            DropdownMenuPrimitive.Content,
            __spreadProps(__spreadValues({
              align: "start",
              sideOffset: 6,
              onFocus: (e) => {
                if (search) {
                  const input = e.target.querySelector("input");
                  if (input) input.focus();
                }
              }
            }, menu), {
              className: twMerge3(
                "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
                "data-[state=open]:data-[side=bottom]:slide-in-from-top-2 data-[state=closed]:data-[side=bottom]:slide-out-to-top-2",
                "data-[state=open]:data-[side=left]:slide-in-from-right-2 data-[state=closed]:data-[side=left]:slide-out-to-right-2",
                "data-[state=open]:data-[side=right]:slide-in-from-left-2 data-[state=closed]:data-[side=right]:slide-out-to-left-2",
                "data-[state=open]:data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:data-[side=top]:slide-out-to-bottom-2",
                "bg-input-popover border-input-border rounded-S z-50 min-w-[var(--radix-dropdown-menu-trigger-width)] overflow-hidden border",
                menu == null ? void 0 : menu.className
              ),
              children: [
                !!search && /* @__PURE__ */ jsx4(DropdownMenuPrimitive.Item, { asChild: true, children: /* @__PURE__ */ jsx4(
                  Search_default,
                  __spreadProps(__spreadValues({}, typeof search === "object" ? __spreadValues({}, search) : {}), {
                    onLocalSearch: handleSearch
                  })
                ) }),
                /* @__PURE__ */ jsx4(
                  "div",
                  {
                    "data-search": !!search,
                    className: "mini-scrollbar divide-body-level-1 max-h-[calc(var(--radix-dropdown-menu-content-available-height)-20px)] divide-y overflow-y-auto data-[search=true]:max-h-[calc(var(--radix-dropdown-menu-content-available-height)-80px)]",
                    children: filterdOptions.length > 0 ? filterdOptions.map((option) => /* @__PURE__ */ jsx4(
                      DropdownMenuPrimitive.Item,
                      {
                        onSelect: () => {
                          onChange == null ? void 0 : onChange(option);
                        },
                        asChild: true,
                        children: /* @__PURE__ */ jsx4(Item_default, __spreadValues({ option, value: selected }, item), option.value)
                      },
                      option.value
                    )) : /* @__PURE__ */ jsx4("div", { className: "p-4 py-12 text-center", children: t("ui_common:no_results") })
                  }
                )
              ]
            })
          ) })
        ] }),
        (typeof error === "string" && !!error || !hideErrorSpace) && /* @__PURE__ */ jsx4(
          Typography_default,
          {
            color: "error",
            variant: "body-S",
            className: `min-h-4 py-1 ${error ? "visible" : "text-transparent"}`,
            children: error
          }
        )
      ]
    }
  );
};
var Menu_default = MenuList;

// src/Menu/Responsive.tsx
import { Fragment as Fragment2, useMemo as useMemo3, useState as useState2 } from "react";
import * as DropdownMenuPrimitive2 from "@radix-ui/react-dropdown-menu";
import { twMerge as twMerge4 } from "tailwind-merge";
import { useTranslation as useTranslation4 } from "@wbk/config";
import { StrokeCheckIcon } from "@wbk/svg";
import { Fragment as Fragment3, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var ResponsiveMenu = ({
  options,
  value,
  onChange,
  render,
  trigger,
  menu,
  item,
  sheet,
  search,
  className,
  error,
  hideErrorSpace,
  multiple,
  ref,
  portal = true
}) => {
  const [query, setQuery] = useState2();
  const [isOpen, setIsOpen] = useState2(false);
  const { dir } = useUi();
  const { t } = useTranslation4("ui_common");
  const Portal3 = portal ? DropdownMenuPrimitive2.Portal : Fragment2;
  const open = () => {
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
  };
  const handleSearch = (value2) => {
    setQuery(value2);
  };
  const selected = useMemo3(() => {
    if (multiple) {
      return options.filter(
        (op) => value == null ? void 0 : value.some((item2) => {
          const itemValue = item2 instanceof Object ? item2.value : item2;
          return itemValue === op.value;
        })
      );
    }
    if (value == null ? void 0 : value.value) {
      return value;
    }
    return options.find((o) => o.value === value);
  }, [value, options, multiple]);
  const filterdOptions = useMemo3(() => {
    if (!query) return options;
    return options.filter(
      (option) => {
        var _a, _b, _c, _d;
        return ((_b = (_a = option.keyword) == null ? void 0 : _a.toLowerCase()) == null ? void 0 : _b.includes(query.toLowerCase())) || ((_d = (_c = option.value) == null ? void 0 : _c.toLowerCase()) == null ? void 0 : _d.includes(query.toLowerCase()));
      }
    );
  }, [options, query]);
  return /* @__PURE__ */ jsxs3("div", { className, children: [
    /* @__PURE__ */ jsx5(
      Responsive_default,
      __spreadProps(__spreadValues({
        render: (props) => {
          if (render) {
            return /* @__PURE__ */ jsx5("div", { className: "w-full md:hidden", children: render(__spreadProps(__spreadValues({}, props), { selected })) });
          }
          return /* @__PURE__ */ jsx5(
            Trigger_default,
            __spreadProps(__spreadValues({}, trigger), {
              ref,
              onClick: () => {
                props.open();
                if (trigger == null ? void 0 : trigger.onClick) {
                  trigger.onClick();
                }
              },
              className: twMerge4(trigger == null ? void 0 : trigger.className, "w-full md:hidden"),
              value: selected
            })
          );
        },
        body: ({ close: close2 }) => /* @__PURE__ */ jsxs3(Fragment3, { children: [
          !!search && /* @__PURE__ */ jsx5(
            Search_default,
            __spreadProps(__spreadValues({
              groupClassName: "px-6 pb-2"
            }, typeof search === "object" ? __spreadValues({}, search) : {}), {
              onLocalSearch: handleSearch
            })
          ),
          filterdOptions.length > 0 ? filterdOptions.map((option) => {
            const checked = multiple ? selected == null ? void 0 : selected.some((o) => o.value === option.value) : (selected == null ? void 0 : selected.value) === option.value;
            return multiple ? /* @__PURE__ */ jsxs3(
              Item_default,
              __spreadProps(__spreadValues({
                option,
                value: selected,
                className: "flex items-center justify-between gap-2"
              }, item), {
                onClick: () => {
                  onChange == null ? void 0 : onChange(
                    checked ? selected.filter((v) => v.value !== option.value) : [...selected, option]
                  );
                },
                children: [
                  /* @__PURE__ */ jsx5("span", { children: option.text || option.label || option.value }),
                  /* @__PURE__ */ jsx5("div", { className: "h-5 w-5 shrink-0 rounded-sm border", children: checked && /* @__PURE__ */ jsx5(StrokeCheckIcon, { className: "bg-primary h-full w-full shrink-0 p-px" }) })
                ]
              }),
              option.value
            ) : /* @__PURE__ */ jsx5(
              Item_default,
              __spreadProps(__spreadValues({
                option,
                value: selected
              }, item), {
                onClick: () => {
                  onChange == null ? void 0 : onChange(option);
                  close2();
                }
              }),
              option.value
            );
          }) : /* @__PURE__ */ jsx5("div", { className: "p-4 py-12 text-center", children: t("ui_common:no_results") })
        ] }),
        type: "sheet",
        actionsStyle: "fixed",
        cancel: false,
        action: false,
        fullscreen: !!search
      }, sheet), {
        className: twMerge4(
          "md:hidden first:[&>div>div]:p-0",
          // IOS device input focus issue breaks animation
          search ? "data-[state=open]:duration-0" : "",
          sheet == null ? void 0 : sheet.className
        )
      })
    ),
    /* @__PURE__ */ jsxs3(DropdownMenuPrimitive2.Root, { dir, open: isOpen, onOpenChange: (open2) => setIsOpen(open2), children: [
      render ? /* @__PURE__ */ jsx5("div", { className: "hidden md:flex", children: /* @__PURE__ */ jsx5(DropdownMenuPrimitive2.Trigger, { ref, asChild: true, children: render({ close, open, isOpen, selected }) }) }) : /* @__PURE__ */ jsx5(DropdownMenuPrimitive2.Trigger, { className: "hidden md:flex", ref, asChild: true, children: /* @__PURE__ */ jsx5(Trigger_default, __spreadProps(__spreadValues({}, trigger), { value: selected })) }),
      /* @__PURE__ */ jsx5(Portal3, { children: /* @__PURE__ */ jsxs3(
        DropdownMenuPrimitive2.Content,
        __spreadProps(__spreadValues({
          align: "start",
          sideOffset: 6,
          onFocus: (e) => {
            if (search) {
              const input = e.target.querySelector("input");
              if (input) input.focus();
            }
          }
        }, menu), {
          className: twMerge4(
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
            "data-[state=open]:data-[side=bottom]:slide-in-from-top-2 data-[state=closed]:data-[side=bottom]:slide-out-to-top-2",
            "data-[state=open]:data-[side=left]:slide-in-from-right-2 data-[state=closed]:data-[side=left]:slide-out-to-right-2",
            "data-[state=open]:data-[side=right]:slide-in-from-left-2 data-[state=closed]:data-[side=right]:slide-out-to-left-2",
            "data-[state=open]:data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:data-[side=top]:slide-out-to-bottom-2",
            "bg-input-popover border-input-border rounded-S z-50 hidden min-w-[var(--radix-dropdown-menu-trigger-width)] overflow-hidden border md:block",
            menu == null ? void 0 : menu.className
          ),
          children: [
            !!search && /* @__PURE__ */ jsx5(DropdownMenuPrimitive2.Item, { asChild: true, children: /* @__PURE__ */ jsx5(
              Search_default,
              __spreadProps(__spreadValues({}, typeof search === "object" ? __spreadValues({}, search) : {}), {
                onLocalSearch: handleSearch
              })
            ) }),
            /* @__PURE__ */ jsx5(
              "div",
              {
                "data-search": !!search,
                className: "mini-scrollbar divide-body-level-1 max-h-[calc(var(--radix-dropdown-menu-content-available-height)-20px)] divide-y overflow-y-auto data-[search=true]:max-h-[calc(var(--radix-dropdown-menu-content-available-height)-80px)]",
                children: filterdOptions.length > 0 ? filterdOptions.map((option) => {
                  const isChecked = multiple ? selected == null ? void 0 : selected.some((o) => o.value === option.value) : (selected == null ? void 0 : selected.value) === option.value;
                  return multiple ? /* @__PURE__ */ jsx5(
                    DropdownMenuPrimitive2.CheckboxItem,
                    {
                      asChild: true,
                      onSelect: (e) => {
                        e.preventDefault();
                      },
                      checked: isChecked,
                      onCheckedChange: (checked) => {
                        onChange == null ? void 0 : onChange(
                          checked ? [...selected, option] : selected.filter((v) => v.value !== option.value)
                        );
                      },
                      children: /* @__PURE__ */ jsxs3(
                        Item_default,
                        __spreadProps(__spreadValues({
                          option,
                          value: selected,
                          className: "flex items-center justify-between gap-2"
                        }, item), {
                          children: [
                            /* @__PURE__ */ jsx5("span", { children: option.text || option.label || option.value }),
                            /* @__PURE__ */ jsx5("div", { className: "h-5 w-5 shrink-0 rounded-sm border", children: isChecked && /* @__PURE__ */ jsx5(StrokeCheckIcon, { className: "bg-primary h-full w-full shrink-0 p-px" }) })
                          ]
                        })
                      )
                    },
                    option.value
                  ) : /* @__PURE__ */ jsx5(
                    DropdownMenuPrimitive2.Item,
                    {
                      onSelect: () => {
                        onChange == null ? void 0 : onChange(option);
                      },
                      asChild: true,
                      children: /* @__PURE__ */ jsx5(Item_default, __spreadValues({ option, value: selected }, item), option.value)
                    },
                    option.value
                  );
                }) : /* @__PURE__ */ jsx5("div", { className: "p-4 py-12 text-center", children: t("ui_common:no_results") })
              }
            )
          ]
        })
      ) })
    ] }),
    (typeof error === "string" && !!error || !hideErrorSpace) && /* @__PURE__ */ jsx5(
      Typography_default,
      {
        color: "error",
        variant: "body-S",
        className: `min-h-4 py-1 ${error ? "visible" : "text-transparent"}`,
        children: error
      }
    )
  ] });
};
var Responsive_default2 = ResponsiveMenu;

export {
  Menu_default,
  Responsive_default2 as Responsive_default
};
//# sourceMappingURL=chunk-MYUAKSYJ.mjs.map